// Kontakte (Billtoro Paket 3): Ansprechpartner, Dateien und Schlagwörter an Kunden und Lieferanten. Antworten des
// Servers (server/src/modules/rechnungstool/kontakte.ts, kontakt-routes.ts, kontakt-dateien.ts) und Adressen.

export type KontaktArt = 'kunde' | 'lieferant';

// Ansprechpartner; kopie: bekommt Belege per E-Mail in Kopie (nur bei Kunden)
export interface Person {
  id: string;
  name: string;
  funktion: string | null;
  email: string | null;
  phone: string | null;
  kopie: boolean;
  pos: number;
}

// Datei am Kontakt (PDF oder Foto); am: Tag des Ablegens. stundenzettel: aus dem Stundenzettel-Stapel abgelegt, mit
// Ordner (Objekt) und der Rechnung dazu (Nummer) bzw. noch im Entwurf; wartet: noch ohne Kunden (neuer Kunde, den erst
// die Rechnung anlegt)
export interface KontaktDatei {
  id: string;
  name: string;
  mime: string;
  groesse: number;
  am: string;
  stundenzettel?: { ordner: string; rechnung: string | null; entwurf: boolean; wartet: boolean };
}

// Schlagwort der Firma mit der Zahl der Kunden und Lieferanten, die es tragen
export interface FirmaSchlagwort {
  wort: string;
  kunden: number;
  lieferanten: number;
}

// höchstens so viele (wie der Server, kontakte.ts und kontakt-dateien.ts)
export const SCHLAGWOERTER_MAX = 10;
export const SCHLAGWORT_LAENGE = 30;
export const PERSONEN_MAX = 20;
export const DATEIEN_MAX = 20;

export const personenUrl = (art: KontaktArt, id: string) => `/api/rechnungstool/${art}/${id}/personen`;
export const personUrl = (id: string) => `/api/rechnungstool/kontaktperson/${id}`;
export const dateienUrl = (art: KontaktArt, id: string) => `/api/rechnungstool/${art}/${id}/dateien`;
export const dateiUrl = (id: string) => `/api/rechnungstool/kontaktdatei/${id}`;
export const schlagwoerterUrl = (firmId: string) => `/api/rechnungstool/${firmId}/schlagwoerter`;
// alle Dateien der Firma als ZIP (Recht „Exporte“)
export const dateienZipUrl = (firmId: string) => `/api/rechnungstool/${firmId}/kontakte/dateien`;

// Suche in Schlagwörtern und (vom Server) in Namen und E-Mails der Ansprechpartner
export const passtZuKontakt = (k: { schlagwoerter: string[]; suchtext: string }, t: string) =>
  k.suchtext.includes(t) || k.schlagwoerter.some((w) => w.toLowerCase().includes(t));

// gleiches Schlagwort ohne Rücksicht auf Groß und klein
export const gleichesWort = (a: string, b: string) => a.toLowerCase() === b.toLowerCase();

// Satz im Fenster „entfernen?“: nennt nur, was am Kontakt wirklich mit gelöscht wird (Kanzlei-App: dateien null);
// Stundenzettel offener Entwürfe bleiben am Entwurf (der Server nimmt sie nicht mit)
export function mitGeloeschtText(personen: Person[], dateien: KontaktDatei[] | null) {
  const weg = (dateien ?? []).filter((d) => !d.stundenzettel?.entwurf);
  const teile = [personen.length ? 'Ansprechpartner' : '', weg.length ? 'Dateien' : ''].filter(Boolean);
  return teile.length ? `Seine ${teile.join(' und ')} werden mit gelöscht.` : '';
}
